import React from 'react'

export type EmptyStateIcon = 'inbox' | 'search' | 'error' | 'success' | 'warning' | 'info'

const iconMap: Record<EmptyStateIcon, string> = {
  inbox: '📭',
  search: '🔍',
  error: '⚠️',
  success: '✅',
  warning: '⚡',
  info: 'ℹ️',
}

export interface EmptyStateProps {
  icon?: EmptyStateIcon
  title: string
  description?: string
  action?: {
    label: string
    onClick: () => void
  }
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon = 'inbox',
  title,
  description,
  action,
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 text-center">
      <div className="text-5xl mb-4">{iconMap[icon]}</div>
      <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">{title}</h3>
      {description && <p className="text-gray-600 dark:text-gray-400 mb-6 max-w-sm">{description}</p>}
      {action && (
        <button
          onClick={action.onClick}
          className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold transition-colors"
        >
          {action.label}
        </button>
      )}
    </div>
  )
}
